var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirecting"},[_c('span',[_vm._v(" Redirecting.... ")]),(_vm.isClusterSelectionOpen)?_c('div',{staticClass:"cluster-container"},[_c('cluster-selection',{on:{"login":_vm.clusterSelected}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }